import { useRef } from 'react'
import { FaFileAlt } from 'react-icons/fa'
import { FiTrash2, FiUpload } from 'react-icons/fi'

export const UploadDocuments = ({ onSelectFiles, selectedFiles = [], setSelectedFiles }) => {
	const inputRef = useRef(null)

	const addFiles = files => {
		const filesArray = Array.from(files)
		const newFiles = filesArray.filter(file => !selectedFiles.some(f => f.name === file.name && f.size === file.size))
		const updatedFiles = [...selectedFiles, ...newFiles]
		setSelectedFiles(updatedFiles)
		onSelectFiles(updatedFiles)
	}

	const handleDrop = e => {
		e.preventDefault()
		addFiles(e.dataTransfer.files)
	}

	const handleFileChange = e => {
		addFiles(e.target.files)
		e.target.value = ''
	}

	const handleRemove = fileToRemove => {
		const updatedFiles = selectedFiles.filter(file => !(file.name === fileToRemove.name && file.size === fileToRemove.size))
		setSelectedFiles(updatedFiles)
		onSelectFiles(updatedFiles)
	}

	const handleDragOver = e => {
		e.preventDefault()
	}

	return (
		<div className=''>
			<div
				className='tw-border-2 tw-border-dashed tw-border-purple-400 tw-rounded-xl tw-p-6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-mb-2'
				onClick={() => inputRef.current.click()}
				onDrop={handleDrop}
				onDragOver={handleDragOver}
				style={{ transition: 'border-color 0.2s' }}
			>
				<FiUpload className='tw-text-purple-400 tw-text-3xl tw-mb-2' />
				<span className='tw-text-purple-400 tw-text-base tw-text-center'>Arrastra y suelta tus archivos aquí o haz clic para seleccionarlos</span>
				<input ref={inputRef} type='file' multiple className='tw-hidden' onChange={handleFileChange} />
			</div>
			{selectedFiles.length > 0 && (
				<div className='tw-mt-2'>
					{selectedFiles.map(file => (
						<div
							key={file.name + file.size}
							className='tw-flex tw-items-center tw-justify-between tw-py-4 tw-px-5 tw-shadow-sm border tw-rounded-xl tw-mb-2'
						>
							<div className='tw-flex tw-items-center tw-gap-2'>
								<FaFileAlt className='tw-text-blue-500 tw-h-4 tw-w-4' />
								<span className='tw-text-gray-700 tw-text-sm'>{file.name}</span>
							</div>
							<div type='button' className='tw-text-black tw-p-1' onClick={() => handleRemove(file)} title='Eliminar'>
								<FiTrash2 />
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
